<template>
    <div class="law-header">
        <div
            class="header-main"
            :class="[
                isLawyerConfirmPage ? 'header-main-confirm' : '',
            ]"
        >
            <!-- <div class="column">
                <div class="logo">
                    <div>
                        <img class="logo-pic" :src="ind[industry].logo"/>
                        <span class="line"></span>
                        <span class="logo-name">百度旗下专业法律服务平台</span>
                    </div>
                </div>
            </div> -->
            <div v-if="isShowUser" class="user">
                <!-- <Poptip
                    v-if="isShowMsg && !isLawyerConfirmPage"
                    v-model="msgtab"
                    trigger="hover"
                    class="msg-poptip"
                > -->
                <!-- 律师任务中心-律师端才有 -->
                <!-- <task-center v-if="+userInfoNew.user_role === 0 && isNotRoute"></task-center> -->
                <div
                    v-if="isShowMsg && !isLawyerConfirmPage"
                    class="header-actions"
                >
                    <div class="guide-actions">
                        <!-- 在线客服 -->
                        <div
                            class="wise-guide kefu"
                            @click="goToOnlineService"
                        >
                            <div class="icon kefu-icon"></div>
                            <p class="wise-guide-txt kefu-text">在线客服</p>
                        </div>
                        <span class="user-line"></span>
                        <div
                            class="wise-guide mr-18"
                            @mouseenter="showMobileGuide"
                            @mouseleave="hideMobileGuide"
                        >
                            <div class="icon app-icon"></div>
                            <p class="wise-guide-txt">手机版</p>
                            <div
                                v-if="activeMobileGuide"
                                class="guide-card mobile-guide-card"
                            >
                                <p class="card-title">随时查客户、领线索，跟进更高效</p>
                                <div class="mobile-qrcode-list">
                                    <div
                                        v-for="qr in mobileQrList"
                                        :key="qr.key"
                                        class="mobile-qrcode-item"
                                    >
                                        <div class="qrcode">
                                            <img
                                                v-if="qr.qrcodeUrl"
                                                :src="qr.qrcodeUrl"
                                                :alt="qr.label"
                                            >
                                            <p class="mobile-qrcode-label">{{ qr.label }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="header-action-item" @click="goToVipCenter">
                        <div class="header-action-icon">
                            <div class="action-icon vip-center-icon"></div>
                        </div>
                        <div class="header-action-label">会员中心</div>
                    </div>
                    <div
                        v-if="hasUnreadMsg"
                        class="msg-poptip"
                        @mouseenter="openMsgPop"
                        @mouseleave="closeMsgPop"
                    >
                        <div class="header-action-item mr-18">
                            <div class="header-action-icon">
                                <veui-badge
                                    v-if="statistics.unread && +statistics.unread !== 0"
                                    class="msg-badge"
                                    :value="statistics.unread"
                                >
                                    <div class="action-icon msg-icon"></div>
                                </veui-badge>
                                <div
                                    v-else
                                    class="action-icon msg-icon"
                                ></div>
                            </div>
                            <div class="header-action-label">消息</div>
                        </div>
                        <div
                            v-if="msgtab"
                            class="unread-msg-popup"
                        >
                            <div class="unread-msg-popup-header">
                                <span class="unread-msg-popup-title">
                                    有{{ unreadMsgList.length }}条未读消息
                                </span>
                                <span
                                    v-if="unreadMsgList.length"
                                    class="unread-msg-popup-mark"
                                    @click="markAllRead"
                                >全部已读</span>
                            </div>
                            <div class="unread-msg-popup-list">
                                <div
                                    v-for="(item, index) in unreadMsgList"
                                    :key="item.id || index"
                                    class="unread-msg-popup-item"
                                >
                                    <!--bca-disable-next-line-->
                                    <div
                                        v-if="!item.isText"
                                        class="unread-msg-popup-item-content"
                                        v-html="item.msg_info && item.msg_info.content"
                                    ></div>
                                    <div v-else class="unread-msg-popup-item-content">
                                        <span>{{ item.msgList[0] }}</span>
                                        <span>请扫码联系运营</span>
                                        <span>{{ item.msgList[1] }}</span>
                                    </div>
                                    <div class="unread-msg-popup-item-time">
                                        {{ formatMsgDate(item.create_time) }}
                                    </div>
                                </div>
                            </div>
                            <div class="unread-msg-popup-footer" @click="onViewMsg">
                                <span>查看全部</span>
                                <img
                                    class="arrow"
                                    src="https://lvlin-fe-saas.bj.bcebos.com/home/module-arrow.svg"
                                >
                            </div>
                        </div>
                    </div>
                    <div
                        v-else
                        class="header-action-item"
                        @click="onViewMsg"
                    >
                        <div class="header-action-icon">
                            <div class="action-icon msg-icon"></div>
                        </div>
                        <div class="header-action-label">消息</div>
                    </div>
                    <div class="header-action-item mr-0" @click="goToConsultSetting">
                        <div class="header-action-icon">
                            <div class="action-icon consult-setting-icon"></div>
                        </div>
                        <div class="header-action-label">咨询设置</div>
                    </div>
                    <!-- ui样式改版，下线消息中心pop -->
                    <!-- <div slot="content" class="ivu-table-filter-list">
                        <div
                            v-if="!isLawyerConfirmPage"
                            class="ivu-table-filter-select-item msg-info"
                            :pointer="!isMsgPage"
                            @click="viewMsg"
                        >
                            消息中心{{
                                statistics.total ? `(${statistics.total})` : ""
                            }}
                        </div>
                    </div> -->
                </div>
                <!-- </Poptip> -->
                <span class="user-line"></span>
                <div class="user-set">
                    <Poptip
                        v-model="usertab"
                        class="usertip"
                        trigger="hover"
                        placement="bottom"
                        @on-popper-show="onAvatarHover"
                    >
                        <div class="info">
                            <div class="info-icon">
                                <img
                                    v-if="lawyerInfo.personal_avatar"
                                    :src="lawyerInfo.personal_avatar"
                                    alt=""
                                >
                                <img
                                    v-else
                                    src="https://lvlin-base.bj.bcebos.com/fe-saas/component/header/user-icon.png"
                                    alt=""
                                >
                            </div>
                            <!-- <div pointer>
                                {{ name }}
                            </div> -->
                        </div>
                        <div slot="content">
                            <div class="ivu-table-filter-list">
                                <ul class="ivu-table-filter-list-single">
                                    <li
                                        v-if="!isUc"
                                        class="ivu-table-filter-select-item"
                                        @click="usertab = false"
                                    >
                                        <p pointer @click="goToPassSetting">
                                            账号设置
                                        </p>
                                    </li>
                                    <li
                                        v-if="!isSettlePage && !isLawyerConfirmPage"
                                        class="ivu-table-filter-select-item"
                                        @click="usertab = false"
                                    >
                                        <p pointer @click="goToMaterial">
                                            个人资料
                                        </p>
                                    </li>
                                    <li class="ivu-table-filter-select-item">
                                        <p pointer @click="lawLogout">退出</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </Poptip>
                </div>
                <div
                    v-if="showNewVideoTemplateTip"
                    v-visually="{
                        serverId: 20099,
                        area: 'new-video-modal',
                    }"
                    class="new-video-template-tip"
                >
                    <div class="new-video-template-tip-title">
                        <span class="new-video-template-tip-title-icon"></span>
                        您有新的视频模板待启用
                        <span
                            class="new-video-template-tip-title-close"
                            @click="clickClose"
                        ></span>
                    </div>
                    <div class="new-video-template-tip-content">
                        您有新的视频模板审核通过待启用，请尽快查看效果并启用，提升数字人视频质量
                    </div>
                    <div
                        class="new-video-template-tip-btn"
                        @click="toHotQuestion"
                    >
                        立即查看
                    </div>
                </div>
            </div>
            <!-- 授权成功弹窗 -->
            <vip-authorize-modal
                :show="isAuthorizeShow"
                :authorized="true"
                @cancel="isAuthorizeShow = false"
            />
            <!-- 弹窗管理 -->
            <c-popup
                @showAuthModal="isAuthorizeShow = true"
                @carouselChange="carouselChange"
            />
        </div>
    </div>
</template>

<script>
/**
 * @desc 法律 header
 * @author baoleilei<baoleilei@baidu.com>
 * @file lawHeader.vue
 * @date 2020-09-25
 */

import {mapState, mapActions, mapMutations} from 'vuex';
import {Badge} from 'veui';
import 'veui-theme-dls-icons/envelope';
import {passportOrigin} from '../../config/constant';
import get from 'lodash/get';
import VipAuthorizeModal from '@/components/vip/vip-authorize-modal';
// 模板引用与组件注册已注释，import 一并注释；恢复时同步恢复
// import taskCenter from './law/task-center.vue';
import dayjs from 'dayjs';
import Popup from './popup/Popup.vue';
import {AsyncQueue} from '@/utils/asyncQueue.js';

const url = {
    // 消息统计
    statisticsMsg: '/bp/api/msg/statistics',
    // 消息列表
    listMsg: '/bp/api/msg/listMsg',
    // 全部已读
    setRead: '/bp/api/msg/setread',
    functionRelease: 'law:/themis/law/msg/functionrelease',
    // 新消息推送
    gerMessageData: '/bp/functionrelease/getfunctionrelease'
};

// 不跳转首页的路由
const notGoHomeRouters = ['setting', 'home', 'Select'];
export default {
    name: 'lawHeader',
    components: {
        'veui-badge': Badge,
        'vip-authorize-modal': VipAuthorizeModal,
        // 模板引用（L21）已注释，此处注册一并注释以通过 vue/no-unused-components
        // 'task-center': taskCenter,
        'c-popup': Popup
    },
    created() {
        // 获取队列实例
        this.asyncQueue = AsyncQueue.getInstance();
    },
    data() {
        return {
            usertab: false,
            msgtab: false,
            industry: 'law',
            passSettingUrl: `${passportOrigin}/v6/ucenter?_t${parseInt(
                Date.now() / 1000,
                10
            )}`,
            isRuningDialog: false, // 是否运行弹窗函数
            editDialogShow: false, // 是否展示认证确认弹窗
            // 消息列表
            messageList: null,
            isLawyerConfirmPage: false,
            isFromFirmAuth: false,
            isAuthorizeShow: false, // 授权成功弹窗
            asyncQueue: null, // 弹窗队列实例
            showNewVideoTemplateTip: false,
            activeMobileGuide: false,
            mobileQrList: [
                {
                    key: 'app',
                    label: '扫码下载APP',
                    qrcodeUrl: 'https://lvlin-fe-saas.cdn.bcebos.com/lawInfo/app-down-qrcode.png'
                },
                {
                    key: 'miniProgram',
                    label: '法行宝微信小程序',
                    qrcodeUrl: 'https://lvlin-fe-saas.cdn.bcebos.com/assets/wx-qrcode-pc.png'
                },
                {
                    key: 'serviceAccount',
                    label: '法行宝律师服务号',
                    qrcodeUrl: 'https://lvlin-fe-saas.cdn.bcebos.com/assets/lvlin-service-img.jpg'
                }
            ],
            // 未读消息列表
            unreadMsgList: []
        };
    },
    methods: {
        ...mapMutations({
            setStatistics: 'Statistics/setStatistics'
        }),
        ...mapActions({
            logout: 'logout'
        }),
        goToPassSetting() {
            this.$wywLog.send({
                serverId: 17144,
                area: 'avatar-passcenter',
                action: 'click'
            });
            window.open(this.passSettingUrl);
        },
        lawLogout() {
            this.$wywLog.send({
                serverId: 17144,
                area: 'avatar-logout',
                action: 'click'
            });
            sessionStorage.removeItem('accountComplete');
            const {authToken} = this.$route.query || {};
            this.logout(authToken);
        },
        // 鼠标移入头像
        onAvatarHover() {
            this.$wywLog.send({
                serverId: 17144,
                area: 'lawyer-avatar',
                action: 'show'
            });
        },
        goToMaterial() {
            this.$wywLog.send({
                serverId: 17144,
                area: 'avatar-material',
                action: 'click'
            });
            // 律所
            if (this.userInfoNew.user_role === 2) {
                this.$route.name !== 'firmintro' && this.$router.push({
                    name: 'firmintro',
                    query: {
                        viewMsg: true
                    }
                });
                return;
            }
            if (this.$route.name !== 'material') {
                this.$router.push({
                    name: 'material',
                    query: {
                        viewMsg: true
                    }
                });
            }
        },
        /**
         * 处理弹窗事件
         */
        runDialog() {
            if (this.$route.name === 'claim-lawyer') {
                return;
            }
            if (this.isRuningDialog) {
                return;
            }
            const today = new Date().toISOString().slice(0, 10);
            if (
                Object.keys(this.userInfoNew).length
                && this.messageList
                && Object.keys(this.vipInfo).length
                && this.authenticationStatus
            ) {
                // 智能体创建弹窗-新
                // this.showCreateAgentNewDialog();

                // 判断本地缓存的和当前时间是否相等，如果不想等，判断百家号状态判断是否展示
                this.isRuningDialog = true;
                let {uk} = this.vipInfo || {};
                let msgWatchList = JSON.parse(localStorage.getItem(
                    `${uk}_newMsgWatchList`) || '[]');
                // 是否有新消息
                let isHasNewMsg = false;
                for (let i = 0; i < this.messageList.length; i++) {
                    let msgItem = this.messageList[i];
                    // 有新的推送消息
                    if (msgWatchList.indexOf(msgItem.id) < 0) {
                        isHasNewMsg = true;
                        this.carouselChange({...this.messageList[0], index: 0});
                        break;
                    }
                }

                // amis弹窗
                if (
                    this.userInfoNew.user_role === 0
                    && !this.isSettlePage
                    && isHasNewMsg
                ) {
                    // 展示弹窗
                    this.asyncQueue.push({
                        type: 'ui-carousel',
                        params: {
                            type: 'show',
                            data: {
                                componentName: 'ui-carousel',
                                componentData: {
                                    list: this.messageList || []
                                }
                            }
                        }
                    });

                    // 消息弹窗曝光
                    this.$wywLog.send({
                        serverId: 16506,
                        action: 'show',
                        page: 'lawinfo',
                        area: 'dialog',
                        index: 0,
                        activityId: this.messageList[0] && this.messageList[0].id
                    });
                    return;
                }


                // 【智能体强引导入口下线一期】PRD3：进入B端的智能体创建引导弹窗下线
                // 注意 is_create 语义反转：1=未创建，0=已创建
                // 注释后弹窗队列顺序前移（会员过期弹窗等会更早触发），需回归其余弹窗优先级
                // // 智能体弹窗
                // const lastShownDate = localStorage.getItem(`${uk}_agentCreateDialogLastShownDate`);
                // // 智能体未创建且认证通过
                // const isShow = (this.agentInfo?.is_create === 1 && this.authenticationStatus === 7) || false;
                // // 如果上次显示日期不存在或不是今天
                // if ((!lastShownDate || lastShownDate !== today) && isShow) {
                //     this.asyncQueue.push({
                //         type: 'agent-create-dialog',
                //         params: {
                //             type: 'show',
                //             data: {
                //                 componentName: 'agent-create-dialog'
                //             }
                //         }
                //     });
                //     this.$wywLog.send({
                //         area: 'agent-create-dialog',
                //         action: 'show',
                //         serverId: 19291
                //     });
                //     localStorage.setItem(`${uk}_agentCreateDialogLastShownDate`, today);

                //     return;
                // }

                // 会员过期弹窗
                if (this.userInfoNew.user_role === 0) {
                    // 免费会员领取/失效弹窗逻辑
                    const freeVipModalShow
                        = localStorage.getItem('freeVipModalShow');
                    const receiveFreeVipTimer = localStorage.getItem('receiveFreeVipTimer');
                    const {canReceiveFreeVip, vipStatus, privilege_info, validityEnd} = this.vipInfo;
                    // freeVipTimer：免费体验会员临期弹窗展示时间
                    const freeVipTimer = localStorage.getItem('aboutToExpireFreeVipTimer');
                    const date1 = freeVipTimer ? dayjs(freeVipTimer).format('YYYY-MM-DD') : '';
                    const date2 = dayjs().format('YYYY-MM-DD');
                    const remainDays = dayjs(validityEnd)?.diff(dayjs(), 'day');
                    let freeVipModalType = '';
                    // 能领取免费体验会员，展示领取弹窗
                    if (canReceiveFreeVip) {
                        const crm_enter_type = this.lawyerInfo?.crm_enter_type || {};
                        freeVipModalType = crm_enter_type === 2 ? 'receive' : '';
                    }
                    // 非会员，且最近过期的是免费体验会员，展示过期弹窗
                    else if (
                        !+vipStatus
                        && privilege_info
                        && privilege_info.vip_code_type === 6
                    ) {
                        freeVipModalType = 'expire-no-avatar';
                    }
                    // 免费体验会员失效的T-3日增加引导弹窗，一天只展示一次
                    else if (remainDays <= 3 && remainDays >= 0 && (!freeVipTimer || date1 !== date2)) {
                        freeVipModalType = 'about-to-expire';
                    }
                    const isShowFreeVipModal
                        = !this.isSettlePage
                            && !this.isFromFirmAuth
                            && this.authenticationStatus >= 7;

                    if (freeVipModalType === 'receive' && isShowFreeVipModal) {
                        if (
                            !receiveFreeVipTimer
                            || (receiveFreeVipTimer
                                && +new Date() - receiveFreeVipTimer > 7 * 24 * 3600 * 1000)
                        ) {

                            this.asyncQueue.push({
                                type: 'free-vip-dialog',
                                params: {
                                    type: 'show',
                                    data: {
                                        componentName: 'free-vip-dialog',
                                        componentData: {
                                            type: freeVipModalType
                                        }
                                    }
                                }
                            });

                            return;
                        }
                    }
                    else if (freeVipModalShow !== freeVipModalType && isShowFreeVipModal) {
                        this.asyncQueue.push({
                            type: 'free-vip-dialog',
                            params: {
                                type: 'show',
                                data: {
                                    componentName: 'free-vip-dialog',
                                    componentData: {
                                        type: freeVipModalType
                                    }
                                }
                            }
                        });

                        return;
                    }
                }
                this.getAccountInfo();
            }
        },
        onViewMsg() {
            this.$wywLog.send({
                serverId: 17144,
                area: 'message-click',
                action: 'click'
            });
            if (this.isUnverified) {
                this.gotoMaterial();
                return;
            }
            if (this.$route.name !== 'lawMessageInfo') {
                this.$router.push({
                    name: 'lawMessageInfo'
                });
            }
        },
        // 跳转到会员中心
        goToVipCenter() {
            this.$wywLog.send({
                serverId: 17144,
                area: 'lawservice-click',
                action: 'click'
            });
            if (this.isUnverified) {
                this.gotoMaterial();
                return;
            }
            if (this.$route.name !== 'lawservice') {
                this.$router.push({
                    name: 'lawservice'
                });
            }
        },
        // 跳转到咨询设置
        goToConsultSetting() {
            this.$wywLog.send({
                serverId: 17144,
                area: 'consultsetting-click',
                action: 'click'
            });
            if (this.isUnverified) {
                this.gotoMaterial();
                return;
            }
            if (this.$route.name !== 'consultSetting') {
                this.$router.push({
                    name: 'consultSetting'
                });
            }
        },
        // 资质未认证时统一跳「我的认证」
        gotoMaterial() {
            if (this.$route.name !== 'material') {
                this.$router.push({name: 'material'});
            }
        },
        showMobileGuide() {
            if (this.activeMobileGuide) {
                return;
            }
            this.activeMobileGuide = true;
            this.$wywLog.send({
                serverId: 17629,
                area: 'fxb-phone',
                action: 'show',
                scene: this.guideType === 1 ? 1 : 0
            });
        },
        hideMobileGuide() {
            this.activeMobileGuide = false;
        },
        openMsgPop() {
            clearTimeout(this.msgPopTimer);
            this.msgtab = true;
        },
        closeMsgPop() {
            clearTimeout(this.msgPopTimer);
            this.msgPopTimer = setTimeout(() => {
                this.msgtab = false;
            }, 120);
        },
        getUnreadMsgList() {
            this.$http
                .get(url.listMsg, {
                    params: {
                        pn: 1,
                        rn: 100
                    }
                })
                .then(res => {
                    if (!res || +res.code !== 0) {
                        return;
                    }
                    const list = res?.data?.list || [];
                    this.unreadMsgList = list.filter(i => +i.is_read === 0).map(i => {
                        const key = '请扫码联系运营';
                        if (i.msg_content?.includes(key)) {
                            return {
                                ...i,
                                isText: true,
                                msgList: i.msg_content.split(key)
                            };
                        }
                        return i;
                    });
                })
                .catch(() => {
                    this.unreadMsgList = [];
                });
        },
        markAllRead() {
            this.$http.post(url.setRead).then(res => {
                if (!res || +res?.code !== 0) {
                    this.$Message.error({
                        content: res?.msg || '数据请求出错',
                        duration: 5
                    });
                    return;
                }
                const data = res?.data;
                if (data) {
                    this.$Message.success('全部标记已读成功');
                    this.getStatistics();
                    this.getUnreadMsgList();
                }
            }).catch(error => {
                this.$Message.error({
                    content: error?.msg || '数据请求出错',
                    duration: 5
                });
            });
        },
        // 时间格式化：yyyy.MM.dd，兼容字符串与时间戳
        formatMsgDate(time) {
            if (!time) {
                return '';
            }
            const normalized = typeof time === 'string'
                ? time.replace(/-/g, '/')
                : time;
            return dayjs(normalized).format('YYYY.MM.DD');
        },
        // 消息统计信息
        getStatistics() {
            if (
                this.industry === 'law'
                && !location.href.includes('filldata')
            ) {
                this.$http
                    .get(url.statisticsMsg)
                    .then(res => {
                        if (!res || +res?.code !== 0) {
                            this.$Message.error({
                                content: res.msg || '数据请求出错',
                                duration: 5
                            });
                            return;
                        }
                        const data = res?.data || {};
                        if (data) {
                            this.setStatistics(data);
                        }
                    })
                    .catch(error => {
                        this.$Message.error({
                            content: error.msg || '数据请求出错',
                            duration: 5
                        });
                    });
            }
        },
        getAccountInfo() {
            const accountComplete = sessionStorage.getItem('accountComplete');
            const consultInfo = get(this.userInfoNew, 'consult_info');
            // 如果本地缓存accountComplete为true，或者userinfo数据未更新的情况，直接返回，不往下请求
            if (accountComplete === 'true' || !consultInfo) {
                return;
            }
            this.$http.get('/bp/api/account/info').then(res => {
                const accountInfo = this.$normalizeResponseData(res);
                // 认证律师未填写银行账号需要弹窗提示
                if (accountInfo && accountInfo.audit_status) {
                    this.editDialogShow
                        = accountInfo.can_modifi
                            && !!+consultInfo.twenty_minute_price;
                    sessionStorage.setItem(
                        'accountComplete',
                        this.editDialogShow
                    );
                }
            });
        },

        /**
         *
         * 百家号相关跳转逻辑
         */

        goToBjh() {
            const bjhRegisterdStatus = this.bjhInfo?.bjh_registerd_status; // 百家号注册状态
            const bjhInfo = this.bjhInfo?.bjh_info || {};
            const subType = bjhInfo.sub_type; // 百家号注册账号type
            // 未注册百家号或百家号注册未通过或百家号账号不是个人账号，跳转百家号注册页面
            if (
                +bjhRegisterdStatus === 0
                || bjhInfo.status === 'unpass'
                || subType !== 'individual'
            ) {
                this.$router.push({
                    name: 'bjhRegister'
                });
                return;
            }
            const toPath = this.bjhNextPath; // 百家号跳转路径
            if (toPath) {
                window.open(toPath);
            }
        },
        /**
         * 请求消息推送信息
         */
        getMessageData() {
            let {vipStatus, privilege_info = {}} = this.vipInfo || {};
            this.$http
                .get(url.gerMessageData, {
                    params: {
                        vip_code_type: privilege_info && privilege_info.vip_code_type || '',
                        vip_status: vipStatus,
                        notification_platform: 1
                    }
                })
                .then(res => {
                    const info = this.$normalizeResponseData(res);
                    this.messageList = info.function_release_list || [];
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                    this.messageList = [];
                });
        },
        /**
         * 新消息推送-轮播切换
         * @param {object} info 轮播信息
         */
        carouselChange(info) {
            let {id, index} = info || {};
            let {uk} = this.vipInfo || {};
            let watchList = JSON.parse(localStorage.getItem(
                `${uk}_newMsgWatchList`) || '[]');
            // 消息弹窗曝光
            this.$wywLog.send({
                serverId: 16506,
                action: 'show',
                page: 'lawinfo',
                area: 'banner',
                index,
                activityId: id
            });
            if (watchList.indexOf(id) > -1) {
                return;
            }
            watchList.push(id);
            localStorage.setItem(
                `${uk}_newMsgWatchList`, JSON.stringify(watchList));
        },
        showCreateAgentNewDialog() {
            // 【智能体强引导入口下线一期】PRD3：智能体创建弹窗-新 下线
            // 注意 is_create 语义反转：1=未创建，0=已创建
            // let showCreateAgentDialog = (this.authenticationStatus === 7 && this.agentInfo.is_create === 1) || false;
            // if (showCreateAgentDialog) {
            //     this.asyncQueue.push({
            //         type: 'agent-create-dialog',
            //         params: {
            //             type: 'show',
            //             data: {
            //                 componentName: 'agent-create-dialog-new'
            //             }
            //         }
            //     });
            //     return;
            // }
        },
        toHotQuestion() {
            this.$wywLog.send({
                serverId: 20099,
                action: 'click',
                area: 'new-video-modal-btn'
            });
            this.showNewVideoTemplateTip = false;
            this.$router.push({
                name: 'hotQuestion',
                query: {showVideoTempModal: '1'}
            });
        },
        clickClose() {
            this.$wywLog.send({
                serverId: 20099,
                action: 'click',
                area: 'new-video-modal-close-btn'
            });
            this.showNewVideoTemplateTip = false;
        },
        getVideoList() {
            this.$http.get('/bp/videotemplate/list', {
                params: {
                    pn: 1,
                    rn: 100,
                    gen_type: 1,
                    video_template_status: 2,
                    audit_status: 1
                }
            }).then(res => {
                if (res.code === '0' && res.data && res.data.list && res.data.list.length > 0) {
                    // 审核通过待启用
                    let videoTemplateList = res.data.list
                        .filter(item => item.audit_status === 1 && !item.selected).map(item => item.id);
                    let uk = this.userInfoNew?.uk;
                    let lastIdList = localStorage.getItem(`${uk}_lastIdList`)?.split(',') || [];
                    if (videoTemplateList.length) {
                        this.showNewVideoTemplateTip = !videoTemplateList
                            .every(item => lastIdList.includes((item + '')));
                    }
                }
            }).catch(err => {});
        },
        goToOnlineService() {
            this.$wywLog.send({
                serverId: 17144,
                area: 'zxkf-btn',
                action: 'click'
            });
            const url = 'https://ufosdk.baidu.com/bailingPC/getEntryPath/1vrBcc5pNe5a1-cvhAFh5otf6AeiYAavnXolKgdMBtY=';
            window.open(url, '_blank');
        }
    },
    watch: {
        userInfoNew() {
            this.runDialog();
        },
        bjhInfo() {
            this.runDialog();
        },
        vipInfo: {
            deep: true,
            immediate: true,
            handler(val) {
                if (val) {
                    const {authToken} = this.$route.query || {};
                    if (authToken) {
                        return;
                    }
                    this.getMessageData();
                }
            }
        },
        bjhNextPath: {
            immediate: true,
            deep: true,
            handler(next) {
                if (next) {
                    this.goToBjh();
                }
            }
        },
        messageList() {
            this.runDialog();
        },
        authenticationStatus: {
            immediate: true,
            handler(val) {
                this.runDialog();
            }
        },
        agentInfo() {
            this.runDialog();
        },
        '$route.query'(val) {
            this.isFromFirmAuth = !!val.formFirmAuth;
            this.runDialog();
        }
    },
    computed: {
        ...mapState({
            bjhInfo: state => state?.lawStore?.bjhInfo,
            userInfoNew: state => state?.lawStore?.userInfoNew,
            authenticationStatus: state => state.lawStore.authenticationStatus,
            vipInfo: state => state.lawStore.vipInfo,
            ind: state => state.Industry.ind,
            statistics: state => state.Statistics.statistics,
            bjhNextPath: state => state.lawStore.bjhNextPath,
            passInfo: state => state.lawStore.userInfoNew?.pass_info || {},
            ucType: state => state.lawStore.userInfoNew?.uc_shadow_type,
            guideType: state => +state.lawStore.guideType,
            lawBusinessInfo: state => state?.lawStore?.userInfoNew?.law_business_info || {},
            lawyerInfo: state => state?.lawStore?.userInfoNew?.lawyer_info || {},
            agentInfo: state => state.lawStore?.agentInfo,
            consultInfo: state => state.lawStore?.userInfoNew?.consult_info,
            authorization: state => state.lawStore?.userInfoNew?.authorization || {}
        }),
        // 资质未认证
        isUnverified() {
            const auditStatus = this.lawyerInfo.audit_status;
            return auditStatus !== undefined && auditStatus !== null && +auditStatus !== 4;
        },
        notGoHome() {
            return notGoHomeRouters.includes(this.$route.name);
        },
        isMsgPage() {
            return this.$route.name === 'lawinfo' && this.$route.query.viewMsg;
        },
        isShowUser() {
            return this.$route.name !== 'introduce-bjh';
        },
        isNotRoute() {
            return this.$route.name !== 'claim-lawyer';
        },
        isShowMsg() {
            let blackList = ['filldata'];
            // uc用户
            if (this.isUc) {
                return false;
            }
            return !blackList.includes(this.$route.name);
        },
        hasUnreadMsg() {
            return this.unreadMsgList.length > 0;
        },
        isSettlePage() {
            // uc用户
            if (this.isUc) {
                return true;
            }
            return ['filldata', 'introduce-bjh'].includes(this.$route.name);
        },
        isUc() {
            return +this.ucType === 1;
        },
        name() {
            const {user_role, law_business_info, pass_info} = this.userInfoNew || {};
            if (user_role === 2 && law_business_info && (law_business_info.name || law_business_info.team_name)) {
                return law_business_info.name + law_business_info.team_name;
            }
            return (pass_info?.pass_name || pass_info?.uname) + '律师';
        }
    },
    mounted() {
        const {authToken} = this.$route.query || {};
        if (authToken) {
            this.isLawyerConfirmPage = true;
            return;
        }
        this.getStatistics();
        this.getUnreadMsgList();
        this.getVideoList();
    }
};
</script>

<style scoped lang="less">
@import "../assets/css/base.less";

.law-header {
    position: relative;
    width: 100%;
    box-shadow: 0 0 0 0;
    .clearfix();

    z-index: 100;

    .mr-18 {
        margin-right: 18px;
    }

    .msg {
        position: relative;
        top: 4px;
        vertical-align: middle;

        img {
            width: 18px;
            height: 25px;
            object-fit: cover;
        }
    }

    .header-actions {
        display: flex;
        align-items: center;
        overflow: visible;

        .msg-poptip {
            position: relative;
            display: inline-flex;
            align-items: center;

            .unread-msg-popup {
                background: #fff;
                border-radius: 8px;
                box-shadow: 0 6px 18px 0 rgba(0, 0, 0, .1);
                position: absolute;
                top: calc(100% + 8px);
                left: 50%;
                transform: translateX(calc(-50% - 24px));
                z-index: 999;
            }
        }

        .header-action-item {
            width: 48px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            line-height: 1;
            user-select: none;
            margin-right: 18px;

            &.mr-0 {
                margin-right: 0;
            }

            .header-action-icon {
                width: 20px;
                height: 20px;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    width: 20px;
                    height: 20px;
                    object-fit: contain;
                }

                .action-icon {
                    width: 20px;
                    height: 20px;
                    background-repeat: no-repeat;
                    background-position: 50%;
                    background-size: 100% 100%;
                }

                .vip-center-icon {
                    background-image: url("https://lvlin-fe-saas.bj.bcebos.com/home/vip-center.svg");
                }

                .msg-icon {
                    background-image: url("https://lvlin-fe-saas.bj.bcebos.com/home/msg-notice.svg");
                }

                .consult-setting-icon {
                    background-image: url("https://lvlin-fe-saas.bj.bcebos.com/home/consult-setting.svg");
                }

                .msg-badge {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        width: 20px;
                        height: 20px;
                        object-fit: contain;
                    }
                }
            }

            &:hover {
                .vip-center-icon {
                    background-image: url("https://lvlin-fe-saas.bj.bcebos.com/home/vip-center-hover.svg");
                }

                .msg-icon {
                    background-image: url("https://lvlin-fe-saas.bj.bcebos.com/home/msg-notice-hover.svg");
                }

                .consult-setting-icon {
                    background-image: url("https://lvlin-fe-saas.bj.bcebos.com/home/consult-setting-hover.svg");
                }
            }

            .header-action-label {
                margin-top: 8px;
                font-size: 12px;
                color: #50525c;
                line-height: 1;
                white-space: nowrap;
            }
        }
    }

    .unread-msg-popup {
        width: 352px;
        display: flex;
        flex-direction: column;
        box-shadow: 0 6px 18px 0 #0000001a;
        border-radius: 12px;
        padding: 18px;
        box-sizing: border-box;

        .unread-msg-popup-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 14px;

            .unread-msg-popup-title {
                font-size: 20px;
                line-height: 1;
                font-weight: 500;
                color: #1e1f24;
            }

            .unread-msg-popup-mark {
                font-size: 14px;
                line-height: 14px;
                color: #848691;
                font-weight: 500;
                cursor: pointer;
            }
        }

        .unread-msg-popup-list {
            width: 100%;
            flex: 1;
            overflow-x: hidden;
            overflow-y: auto;
            max-height: 390px;
        }

        .unread-msg-popup-item {
            padding: 8px 0 12px;
            border-bottom: 1px solid #f7f8fa;

            &:last-child {
                border-bottom: none;
            }

            &:first-child {
                padding-top: 0;
            }
        }

        .unread-msg-popup-item-content {
            font-size: 16px;
            line-height: 28px;
            color: #1e1f24;
            white-space: normal;
            word-break: break-all;

            /deep/ a {
                color: #0054ff;
            }
        }

        .unread-msg-popup-item-time {
            margin-top: 8px;
            font-size: 14px;
            color: #848691;
            line-height: 1;
        }

        .unread-msg-popup-footer {
            width: 100%;
            text-align: center;
            font-size: 16px;
            line-height: 16px;
            color: #1e1f24;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 18px;

            .arrow {
                width: 14px;
                height: 14px;
                margin-left: 4px;
            }
        }
    }

    .envelope {
        font-size: 15px;
    }

    .header-main {
        width: 100%;
        height: 60px;
        line-height: 60px;
        box-sizing: border-box;
        // 解决菜单消失后还可以hover的问题：原因是有一个fade的过程
        /deep/ .du-poptip-popper.fade-leave-to {
            pointer-events: none;
        }

        &.header-main-scrolled {
            background: #f7f9fa;
        }

        .column {
            float: left;
            display: flex;
            height: 100%;
            align-items: center;

            .logo {
                position: relative;
                margin-right: 16px;

                a {
                    display: flex;
                    align-items: center;
                }

                div {
                    display: flex;
                    align-items: center;
                }
            }

            .logo-car {
                height: 72px !important;
            }

            .logo-pic {
                height: 24px;
                width: 157px;
                display: inline-block;
                vertical-align: middle;
            }

            .logo-name {
                font-size: 14px;
                color: #696969;
                vertical-align: middle;
                line-height: 1;
            }

            .line {
                height: 16px;
                width: 1px;
                display: inline-block;
                background: #e9ecf3;
                margin: 0 10px;
            }

            .title {
                font-size: 16px;
                color: #333;
            }
        }

        .user {
            display: flex;
            align-items: center;
            position: relative;
            float: right;
            line-height: 1;
            color: #333;
            height: 100%;

            .user-line {
                display: inline-block;
                width: 1px;
                height: 38px;
                background: rgba(132, 134, 145, .1);
                margin-inline: 18px;
            }

            .msg-info {
                font-size: 14px;
                color: #282c33;
                line-height: 30px;
            }

            .info {
                display: flex;
                justify-content: flex-end;
                align-items: center;
                font-family: PingFangSC-Medium;
                font-size: 16px;
                color: #1e1f24;

                .info-icon {
                    display: block;

                    img {
                        width: 42px;
                        height: 42px;
                        border-radius: 50%;
                        vertical-align: middle;
                        border: 1px solid #fff;
                        background: #ababab;
                    }
                }

                .name {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 14px;
                    color: #333;
                    line-height: 14px;
                }
            }

            .rank {
                background: #4a7cff;
                border-radius: 10px;
                color: #fff;
                padding: 0 8px;
                font-size: 12px;
                margin-left: 7px;
            }

            .oldhand {
                background: #0067ff;
            }

            .guide-actions {
                display: flex;
                align-items: center;

                .wise-guide {
                    position: relative;
                    width: 48px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;

                    &.kefu {
                        cursor: pointer;
                    }

                    .icon {
                        width: 20px;
                        height: 20px;
                    }

                    .kefu-icon {
                        background: url("https://lvlin-fe-saas.bj.bcebos.com/home/kefu-icon.svg") no-repeat;
                        background-size: 100% 100%;
                    }

                    .app-icon {
                        background: url("https://lvlin-fe-saas.bj.bcebos.com/home/down-app.svg") no-repeat;
                        background-size: 100% 100%;
                    }

                    &:hover {
                        .app-icon {
                            background-image: url("https://lvlin-fe-saas.bj.bcebos.com/home/down-app-hover.svg");
                        }
                    }

                    .wise-guide-txt {
                        font-size: 12px;
                        line-height: 12px;
                        color: #50525c;
                        margin-top: 8px;
                        white-space: nowrap;

                        &.kefu-text {
                            color: #06c;
                        }
                    }

                    .guide-card {
                        position: absolute;
                        top: 53px;
                        left: 50%;
                        z-index: 1000;
                        transform: translateX(-50%);
                        text-align: center;
                        cursor: default;

                        &::after {
                            content: "";
                            position: absolute;
                            top: -14px;
                            left: 0;
                            right: 0;
                            height: 14px;
                            background: transparent;
                        }
                    }

                    .mobile-guide-card {
                        padding: 18px 12px 12px;
                        box-sizing: border-box;
                        border-radius: 12px;
                        background-color: #fff;
                        box-shadow: 0 6px 18px 0 #0000001a;

                        .card-title {
                            color: #1e1f24;
                            font-family: PingFang SC;
                            font-size: 18px;
                            line-height: 18px;
                            font-weight: 500;
                            text-align: center;
                            white-space: nowrap;
                        }

                        .mobile-qrcode-list {
                            margin-top: 18px;
                            display: flex;
                            gap: 8px;
                        }

                        .mobile-qrcode-item {
                            display: flex;
                            flex-direction: column;
                            align-items: center;

                            .qrcode {
                                width: 132px;
                                height: 159px;
                                padding: 6px 6px 10px;
                                border-radius: 9px;
                                box-sizing: border-box;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: center;
                                background: #f7f8fa;
                                overflow: hidden;

                                img {
                                    display: block;
                                    width: 120px;
                                    height: 120px;
                                    object-fit: contain;
                                }

                                .mobile-qrcode-label {
                                    margin-top: 10px;
                                    color: #50525c;
                                    font-size: 13px;
                                    line-height: 13px;
                                }
                            }
                        }
                    }
                }
            }
        }
        // 菜单
        /deep/ .ivu-poptip-inner {
            padding: 0;
        }

        .ivu-table-filter-select-item {
            font-size: 14px !important;
            color: #282c33;

            &:first-child {
                border-top-left-radius: 3px;
                border-top-right-radius: 3px;
            }

            &:last-child {
                border-bottom-left-radius: 3px;
                border-bottom-right-radius: 3px;
            }
        }
        // 信息提示
        /deep/ .veui-badge-label {
            text-align: center;
        }

        .user-set {
            /deep/.ivu-table-filter-select-item {
                padding: 0 30px;
            }
        }

        .new-video-template-tip {
            background: #fff;
            width: 352px;
            border-radius: 9px;
            position: absolute;
            top: 76px;
            right: 0;
            box-shadow: 0 6px 18px 0 #0000001a;
            padding: 18px;

            .new-video-template-tip-title {
                color: #1e1f24;
                font-family: PingFang SC;
                font-weight: 500;
                font-style: Medium;
                font-size: 16px;
                line-height: 16px;
                display: flex;
                align-items: center;

                .new-video-template-tip-title-icon {
                    height: 20px;
                    width: 20px;
                    margin-right: 8px;
                    background: url("https://lvlin-fe-saas.cdn.bcebos.com/hotQuestion/new-video-tip-modal/%23icon.png") no-repeat center center / 100% 100%;
                }

                .new-video-template-tip-title-close {
                    height: 20px;
                    width: 20px;
                    position: absolute;
                    right: 18px;
                    top: 18px;
                    cursor: pointer;
                    background: url("https://lvlin-fe-saas.cdn.bcebos.com/hotQuestion/new-video-tip-modal/close.png") no-repeat center center / 100% 100%;
                }
            }

            .new-video-template-tip-content {
                color: #50525c;
                font-family: PingFang SC;
                font-weight: 400;
                font-style: Regular;
                font-size: 14px;
                line-height: 22px;
                margin-top: 10px;
                margin-bottom: 10px;
            }

            .new-video-template-tip-btn {
                background: #0055ff1a;
                width: 80px;
                height: 34px;
                opacity: 1;
                border-radius: 6px;
                color: #05f;
                font-family: PingFang SC;
                font-weight: 500;
                font-style: Medium;
                font-size: 14px;
                line-height: 34px;
                text-align: center;
                float: right;
                cursor: pointer;
            }
        }
    }

    .header-main-confirm {
        width: 1280px;
    }
}

.edit-dialog-content {
    font-family: PingFangSC-Medium;
    font-size: 20px;
    color: #000;
    letter-spacing: 0;
    line-height: 30px;
}
</style>
